import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../../apiCall';
import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';

import { UPDATE_SURGE_EVENT, UPDATE_SURGE_EVENT_SUCCESS, UPDATE_SURGE_EVENT_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* updateEvent({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/event-rules`,
      method: 'POST',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload.data,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message)
      cogoToast.success(`Event updated successfully!`);
      yield put({ type: UPDATE_SURGE_EVENT_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      // yield put({ type: UPDATE_SURGE_EVENT_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: UPDATE_SURGE_EVENT_ERROR, payload: error });
  }
}

export function* watchUpdateEvent() {
  yield takeEvery(UPDATE_SURGE_EVENT, updateEvent);
}

function* updateEventSaga() {
  yield all([fork(watchUpdateEvent)]);
}

export default updateEventSaga;
